import * as React from "react";
import { formatMonthYear } from "./../../utils";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import Stack from 'react-bootstrap/Stack';

export const CustomFilterUI = (props) => {

    const { firstFilterProps,secondFilterProps } = props;
    /*const value = firstFilterProps.value;
    const firstOp = firstFilterProps.operator;*/
    const shouldClear = (item) => ["isnull", "isnotnull"].indexOf(item?.operator) > -1;

    const onChange = (event) => {       
                      
        firstFilterProps.onChange({
            value: event.target.value,
            operator: firstFilterProps.operator,
            syntheticEvent: event.syntheticEvent,
        });
    };

    const onChangeFirstOperator = (event) => {
        var item = event.target.value;

        
        firstFilterProps.onChange({
            value: shouldClear(item) ? "0000-00" : firstFilterProps.value,
            operator: item?.operator,
            syntheticEvent: event.syntheticEvent,
        });
    }

    const onChangeLogicValue = (event) => {               
        props.onLogicChange(event);        
    }

    const onChangeSecond = (event) => {
        const value = event.target.value;
        secondFilterProps.onChange({
            value,
            operator: secondFilterProps.operator,
            syntheticEvent: event.syntheticEvent,
        });
    };

    const onChangeSecondOperator = (event) => {
        var item = event.target.value;
        secondFilterProps.onChange({
            value: secondFilterProps.value,
            value: shouldClear(item)  ? "0000-00" : secondFilterProps.value,
            operator: item?.operator,
            syntheticEvent: event.syntheticEvent,
        });
    }

    return (
        <Stack direction="vertical" gap={2}>
            {/*JSON.stringify(firstFilterProps)*/}
            <DropDownList
                data={firstFilterProps.operators}
                value={props.firstFilterProps?.operators?.find(x => x.operator == props.firstFilterProps.operator) ?? props.firstFilterProps?.operators?.[0]}
                textField="text"
                dataItemKey="operator"
                onChange={onChangeFirstOperator}
            />
            
            <input                
                type="month"
                value={(shouldClear(props.firstFilterProps.operator) ? "": props.firstFilterProps.value) || ""}
                style={{ width:"100%"}}
                
                onChange={onChange}
            />

            <DropDownList
                data={props.logicData}
                value={props.logicData?.find(x => x.operator == props.logicValue.operator) ?? props.logicData?.[0]}
                textField="text"
                dataItemKey="operator"
                onChange={onChangeLogicValue}
            />

            <DropDownList
                data={secondFilterProps.operators}
                value={props.secondFilterProps?.operators?.find(x => x.operator == props.secondFilterProps.operator) ?? props.secondFilterProps?.operators?.[0]}
                textField="text"
                dataItemKey="operator"
                onChange={onChangeSecondOperator}
            />

            <input
                type="month"
                value={(shouldClear(props.secondFilterProps.operator) ? "" : props.secondFilterProps.value) || ""}
                style={{ width: "100%" }}
                onChange={onChangeSecond}
            />

            {/*<label htmlFor="bool-null">&nbsp;not set</label>
            <br />
            <input
                id="bool-true"
                name="boolean"
                type="radio"
                value="true"
                checked={value === true}
                onChange={onChange}
            />
            <label htmlFor="bool-true">&nbsp;true</label>
            <br />
            <input
                id="bool-false"
                name="boolean"
                type="radio"
                value="false"
                checked={value === false}
                onChange={onChange}
            />
            <label htmlFor="bool-false">&nbsp;false</label>*/}
        </Stack>
    );
};